module.exports = __webpack_public_path__ + "img/file-pdf.10089254.png";